module.exports = __webpack_public_path__ + "img/LogoDeVuyst.e113794e.png";